<template>
  <el-dialog
    title="统计分析"
    :modal="false"
    :visible.sync="statisticDialogVisible"
    v-dialogDrag
    :before-close="handleClose"
    :close-on-click-modal="false"
    :show-close="true"
    :close-on-press-escape="false"
  >
    <div style="display: flex;justify-content: center;align-items: center;"> 
      <div style="flex:1;margin-right:20px">
       
        <yjzxstatisticanalysis ref="yjzxChart"></yjzxstatisticanalysis>
      </div>
      <div style="flex:1;">  
        <xxbstatisticanalysis ref="xxbChart"></xxbstatisticanalysis>
      </div>
    </div>    
  </el-dialog>
</template>

<script>
import { initRegion, getRegion,yjzxStatistic } from "@/api/api.js";
import dataListDialog from './dataListDialog.vue'
import yjzxstatisticanalysis from './yjzxstatisticanalysis.vue';
import xxbstatisticanalysis from './xxbstatisticanalysis.vue'
export default {
  components:{
    dataListDialog,
    yjzxstatisticanalysis,
    xxbstatisticanalysis
  },
  data() {
    return {
      disabled1: false,
      disabled2: false,
      disabled3: false,
      sheng: [],
      shi: [],
      xian: [],
      shengValue: '',
      shiValue: '',
      xianValue: '',
      shengCode: '',
      shiCode: '',
      xianCode: '',
      statisticDialogVisible: true,
      //省市县参数
      shengData: null,
      shiData: null,
      xianData: null,
      yjzxPie: null,
      xxbPie: null,
      numyjzxAll: 0,
      numxxbAll: 0,
      regionCode:'',
      yjzxData:[],
      xxbData:[],
      dataListDialogVisible: false,
      regionType: '0' //区域类型是0表示省
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      // window.addEventListener("resize", this.resize());
    });
  },
  methods: {
    getData(data){
      this.numyjzxAll = 0;
      let params = {
            regionCode: data ? data : this.$store.state.regionCode
        };     
      yjzxStatistic(params).then((res=>{
        //淤积专项统计数据
        if(res.data && res.data.yjzxStatistic && res.data.yjzxStatistic.statisticResult.length > 0){
          this.yjzxData = res.data.yjzxStatistic.statisticResult;
          let dataList = res.data.yjzxStatistic.statisticResult;
          dataList.forEach(ele => {
            if(this.xianValue){
              this.regionType = '3'//区域类型是3表示县级别
            }else if(this.shiValue){
              this.regionType = '2';//区域类型是3表示县级别
            }else if(this.shengValue){
              this.regionType = '1' //区域类型是1表示市级别
            }          
            this.numyjzxAll += ele.count;           
          });
          // this.initYjzxPie(res.data.yjzxStatistic.statisticResult);

        }
        //小型坝统计数据
        if(res.data && res.data.xxbStatistic && res.data.xxbStatistic.statisticResult.length > 0){
          this.yjzxData = res.data.xxbStatistic.statisticResult;
          let dataList = res.data.xxbStatistic.statisticResult;
          dataList.forEach(ele => {
            // if(this.xianValue){
            //   this.regionType = '3'//区域类型是3表示县级别
            // }else if(this.shiValue){
            //   this.regionType = '2';//区域类型是3表示县级别
            // }else if(this.shengValue){
            //   this.regionType = '1' //区域类型是1表示市级别
            // }          
            this.numxxbAll += ele.count;           
          });
          // this.initYjzxPie(res.data.yjzxStatistic.statisticResult);

        }

      }))

    },

    handleClose() {
      this.statisticDialogVisible= false;
        this.$emit("getStatisticcancel", {
          statisticDialogVisible: this.statisticDialogVisible
        });
      
    },
    resize(){
      // this.$refs.yjzxChart.resize();
      // this.$refs.xxbChart.resize();
    }
  }
};
</script>

<style scoped="scoped">
.totalPie,
.zrrlist {
  width: 100%;
  height: 270px;
  background: url(../../../common/images/contentborder.png) no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
  font-size: 16px;
}
>>> .el-dialog {
  width: 70%;
}
.el-dialog__body {
  max-height: 200px;
  overflow: auto;
}
.el-form-item__error {
  padding-top: 0;
}
.el-input__inner {
  padding-right: 0;
}
.selectTool {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 500px;
  /* z-index: 100; */
}
</style>
